
<script>
import BarList from '../components/bar-list'
import { apiORDSdelete } from '../shared/api-functions'
import { SysVars } from '../main';
import PdtipoForm from './pdtipo-form'

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            pdtipo: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            currentTipo: {},
            codtipo: null,
        }
    },

    computed: {
        pdtipoList: function () {
            return this.$store.getters.getPdtipoList
        },
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },

    },

    methods: {
        handleEdit (tipo) {
            //abre a tela de edicao
            this.currentTipo = tipo
            this.crud = SysVars.crudU;
            this.$set(tipo, 'show', true)
        },
        
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.showForm = true
        },

        closeForm() {
            this.currentTipo.show = false
            this.showForm = false
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codtipo":{"$like":"%25' + value + '%25"}},{"descricao":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadPdtipo', { filter: this.filter, page: this.nextPage } )
            this.offset = ''
        },

        handleDelete (pdtipo) {
            //BOTAO Excluir
            this.apiDelete(pdtipo)
        },

        async apiDelete (pdtipo) {
            //efetua a exclusao
            var modulo = 'cg/pdtipo/' + pdtipo.codtipo
            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },


    },

    components: {
        BarList, PdtipoForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false" 
                :xls-button="false"
                single-entity="Tipo de Pedido" 
                plural-entity="Tipos de Pedido"
                @search="search"
                @new="handleNew"
                @refresh="loadData">
            </bar-list>
            <br>
            <div class="default-container nb-card-list">
                <alert v-if="pdtipoList.length == 0" type="norecord"></alert>

                <div class="nb-card-inline-form mb-3" v-if="showForm">
                    <pdtipo-form :index="codtipo" :crud="crud" @closeform="closeForm"></pdtipo-form>
                </div>

                <article class="nb-card" v-for="pdtipo in pdtipoList" :key="pdtipo.codtipo">
                    <div class="nb-card-top" v-show="!pdtipo.show">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ pdtipo.descricao }}</h2>
                                </div>
                                <div class="nb-card-code" v-if="pdtipo.codtipo">
                                    Código <strong>{{ pdtipo.codtipo }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid 
                                :options="{barDefault: true, btnDelete: true, btnEdit: true, btnEditLabel: 'Editar'}" 
                                :moreActions="[]" 
                                @edit="handleEdit(pdtipo)" 
                                @view="handleEdit(pdtipo, true)" 
                                @delete="handleDelete(pdtipo)">
                            </bar-grid>
                        </div>
                    </div>

                    <div class="nb-card-inline-form" v-if="pdtipo.show">
                        <pdtipo-form :index="pdtipo.codtipo" :crud="crud" @closeform="closeForm"></pdtipo-form>
                    </div>
                </article>

            </div>
        </div>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-card-inline-form {
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/pdtipo-list.vue